import type { IExtractParams } from "@/routes";
import { apiPathFunc } from "@api/util/apiPathFunc";

const pathBase = `/exam-access-time-restriction-states/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const examAccessTimeRestrictionStates = {
  getAll: apiPathFunc(pathBase),
} as const;
